const RATES = { checkout: 1, product_page: 0.2, all_art: 0.12, home: 0.02, support: 1, control: 0.005 }
const PRODUCT_PATH = /\/Artwork\/([^/]+)/
const ALL_ART_PATH = /^\/(artworks|staff-picks|exclusives|featured-art|sale)(\/|$)/
const CHECKOUT_PATH = /^\/(checkout|carts\/)/
const FUNNEL_EVENTS = ["add_to_cart", "checkout_started", "purchase"]
const PRODUCT_SIGNALS = [
  "pdp_gallery_lightbox_opened",
  "pdp_gallery_image_changed",
  "pdp_view_on_wall_opened",
  "room_photo_modal_opened",
  "pdp_frame_info",
]
const MIRRORED_PREFIXES = ["pdp_", "homepage_", "room_photo_"]
const IMPRESSION_SUFFIXES = ["_shown", "_viewed", "_ready"]

!(function (h, o, t, j, a, r) {
  h.hj =
    h.hj ||
    function () {
      ;(h.hj.q = h.hj.q || []).push(arguments)
    }
  h._hjSettings = { hjid: 471554, hjsv: 6 }
  a = o.getElementsByTagName("head")[0]
  r = o.createElement("script")
  r.async = 1
  r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
  a.appendChild(r)
})(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=")

const session = window.sessionStorage
const { config } = window
let lastIdentity

let experiments = ""

const identify = () => {
  const attributes = {
    bluethumb_uid: config.userUID,
    user_type: config.userSignedIn ? config.userRole : "guest",
    environment: config.railsEnv,
  }
  if (session.hj_surface) attributes.recording_trigger = session.hj_surface
  if (experiments) attributes.experiments = experiments

  const identity = JSON.stringify([config.userUID, attributes])
  if (identity === lastIdentity) return

  lastIdentity = identity
  window.hj("identify", config.userUID, attributes)
}

const updateIntercom = () => {
  if (!session.hj_surface) return

  window.Intercom?.("update", {
    bluethumb_uid: session.hj_user_id,
    hotjar_recorded_at: Number(session.hj_recorded_at),
    hotjar_recording_trigger: session.hj_surface,
  })
}

const record = (surface, signal) => {
  const rolled = session.hj_rolled || ""
  if (session.hj_surface || rolled.includes(`${surface},`)) return false

  session.hj_rolled = `${rolled}${surface},`
  if (Math.random() > RATES[surface]) return false

  session.hj_surface = surface
  session.hj_user_id = config.userUID
  session.hj_recorded_at = Math.floor(Date.now() / 1000)
  window.hj("event", "record_session")
  identify()
  window.posthog?.capture("hotjar_recording_decision", { surface, signal })
  updateIntercom()
  return true
}

const remember = (key, value) => {
  const seen = new Set(JSON.parse(session[key] || "[]"))
  seen.add(value)
  session[key] = JSON.stringify([...seen])
  return seen.size
}

const onScrollPastFold = () => {
  if (window.scrollY < window.innerHeight) return

  window.removeEventListener("scroll", onScrollPastFold)
  record("home", "scrolled")
}

const onChatOpened = () => {
  window.hj("event", "chat_opened")
  record("support", "chat_opened") || updateIntercom()
}

const mirrored = (name) =>
  MIRRORED_PREFIXES.some((prefix) => name.startsWith(prefix)) &&
  !IMPRESSION_SUFFIXES.some((suffix) => name.endsWith(suffix))

const onEventCaptured = ({ event, properties }) => {
  const name = event === "$autocapture" ? properties.surface : event
  if (!name || !mirrored(name)) return

  window.hj("event", name)
  if (PRODUCT_SIGNALS.includes(name)) record("product_page", name)
}

const onFeatureFlags = (_flags, variants = {}) => {
  const next = Object.entries(variants)
    .filter(([, variant]) => typeof variant === "string")
    .map(([flag, variant]) => `${flag}=${variant}`)
    .sort()
    .join(";")
    .slice(0, 200)
  if (next === experiments) return

  experiments = next
  identify()
}

const onEcommerceEvent = ({ event }) => {
  if (!FUNNEL_EVENTS.includes(event)) return

  window.hj("event", event)
  if (event === "checkout_started") session.hj_checkout = "1"
  if (event === "purchase") {
    session.removeItem("hj_checkout")
  } else {
    record("checkout", event)
  }
}

const onPageLoad = () => {
  const { pathname, search } = window.location
  window.removeEventListener("scroll", onScrollPastFold)
  record("control", "session_start")

  if (session.hj_checkout && !CHECKOUT_PATH.test(pathname)) {
    session.removeItem("hj_checkout")
    window.hj("event", "checkout_abandoned")
  }

  const artwork = pathname.match(PRODUCT_PATH)
  if (artwork) {
    if (remember("hj_artworks", artwork[1]) >= 3) record("product_page", "third_artwork")
  } else if (ALL_ART_PATH.test(pathname)) {
    if (remember("hj_feed_pages", pathname + search) >= 2) record("all_art", "second_feed_page")
  } else if (pathname === "/" && !session.hj_surface) {
    window.addEventListener("scroll", onScrollPastFold, { passive: true })
  }

  if (!window.localStorage.hj_returning && (pathname === "/" || ALL_ART_PATH.test(pathname))) {
    window.localStorage.hj_returning = "1"
    record("home", "first_visit")
  }

  identify()
}

const pushEcommerceEvent = window.pushEcommerceEvent
window.pushEcommerceEvent = (event) => {
  pushEcommerceEvent(event)
  onEcommerceEvent(event)
}
window.dataLayer?.forEach(onEcommerceEvent)

window.posthog?.on("eventCaptured", onEventCaptured)
window.posthog?.onFeatureFlags(onFeatureFlags)
document.addEventListener("turbo:load", onPageLoad)
document.addEventListener(
  "turbo:load",
  () => {
    window.Intercom?.("onShow", onChatOpened)
    updateIntercom()
  },
  { once: true },
)
